class visualPresentation extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.getAttribute('data-section-id');
    this.initSlider();
  }

  initSlider() {
    let sectionId = this.sectionId
    let swiperThumb = new Swiper(`.visual-presentation-module-thumb-${sectionId}`, {
      loop: false,
      spaceBetween: 8,
      slidesPerView: 4,
      freeMode: true,
      watchSlidesProgress: true,
      breakpoints: {
        990: {
          slidesPerView: 8,
        }
      },
    });

    new Swiper(`.visual-presentation-slider-${sectionId}`, {
      loop: false,
      spaceBetween: 10,
      thumbs: {
        swiper: swiperThumb,
      },
    });
  }
}
customElements.define('visual-presentation', visualPresentation)